// External Imports
import React from "react";

import WebsiteButton from "../WebsiteButton";
import { useReactToPrint } from "react-to-print";

/**
 * Props for the Print component
 */
interface PrintButtonProps {
    // A ref to the element to print — see the `PrintableArea` each modal wraps
    // its content in.
    printableSection: React.RefObject<HTMLDivElement>;
}

export const PrintButton: React.FC<PrintButtonProps> = ({
    printableSection,
}) => {
    // react-to-print v3 takes the ref itself (`contentRef`); the v2 option this
    // used to pass (`content: () => ref.current`) is no longer read, so printing
    // silently did nothing.
    const handlePrint = useReactToPrint({ contentRef: printableSection });

    // The hook's handler takes an optional content argument, not a click event,
    // so it cannot be used as an onClick directly.
    return (
        <WebsiteButton tag="button" onClick={() => handlePrint()}>
            Print
        </WebsiteButton>
    );
};

export default PrintButton;
